import i18n from 'i18next';

import { EmploymentDurationOption } from '../types/EmploymentDurationOption';
import { HALF_YEAR_IN_MONTHS_AS_STRING } from './halfYear';
import { ONE_YEAR_IN_MONTHS_AS_STRING } from './oneYear';

export const monthsAtIncomeOptions: EmploymentDurationOption[] = [
  {
    name: i18n.t('employmentDuration.moreThan1Year'),
    value: ONE_YEAR_IN_MONTHS_AS_STRING,
  },
  {
    name: i18n.t('employmentDuration.lessThan1Year'),
    value: HALF_YEAR_IN_MONTHS_AS_STRING,
  },
];
